import { FC, JSX } from "react";
import { useJobs } from "@/features/jobs/hooks/useJobs";
import JobOverviewUI from "@/features/jobs/components/overview/job.overview.ui";
import { Spinner } from "@radix-ui/themes";

const JobsOverviewPage: FC = (): JSX.Element => {
  const { data, loading, error } = useJobs("published");

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  if (data) {
    return <JobOverviewUI jobs={data} />;
  }

  return <JobOverviewUI jobs={[]} />;
};

export default JobsOverviewPage;
